import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { PayeeCasesService } from '../payee-cases.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'payee-clear-filters',
  templateUrl: './clear-filters.component.html',
  styleUrls: ['./clear-filters.component.scss'],
  imports: [TranslateModule],
})
export class ClearFiltersComponent implements OnInit, OnDestroy {
  private payeeCasesService = inject(PayeeCasesService);

  private readonly destroy = new Subject<void>();
  hasFilters = false;

  ngOnInit(): void {
    this.payeeCasesService.filters
      .pipe(takeUntil(this.destroy))
      .subscribe(() => {
        const filters = this.payeeCasesService.getFilters();
        this.hasFilters = false;

        for (const [key, value] of Object.entries(filters)) {
          if (key in this.payeeCasesService.ignoredFilters) {
            continue;
          }

          if (value !== null) {
            this.hasFilters = true;
            return;
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  clearFilters(): void {
    const savedValues: [BehaviorSubject<unknown>, unknown][] = [];
    for (const subject of Object.values(
      this.payeeCasesService.ignoredFilters,
    )) {
      savedValues.push([subject, subject.value]);
    }
    this.payeeCasesService.resetFilters();
    for (const [subject, value] of savedValues) {
      subject.next(value);
    }
  }
}
